const _TEMPLATE_FILE_NAME = "clients.csv";
const _TEMPLATE_CONTENT =
  "first_name,last_name,email,phone_number\nAdd your clients,,,\n";

/**
 * Downloads the template field for uploading bulk client list.
 */
export const downloadBulkClientUploadTemplate = () => {
  const blob = new Blob([_TEMPLATE_CONTENT], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = _TEMPLATE_FILE_NAME;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};
